import { render, staticRenderFns } from "./rwstep1.vue?vue&type=template&id=54f48e1b&scoped=true&"
import script from "./rwstep1.vue?vue&type=script&lang=js&"
export * from "./rwstep1.vue?vue&type=script&lang=js&"
import style0 from "./rwstep1.vue?vue&type=style&index=0&id=54f48e1b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f48e1b",
  null
  
)

export default component.exports